module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGUlEQVQoU2N88eLFfwYSAOOoBiJCa0SGEgAZhSyhv+NwtwAAAABJRU5ErkJggg=="